import useAmplitude from '@eversports/amplitude-react/useAmplitude'
import DatePicker from '@eversports/klimt-patterns/DatePicker'
import * as React from 'react'

import { DiscoverFilterTypes } from '../../../../../Discover/Filters/Filters.types'
import type { Action } from '../../helpers/matches-filters-reducer'
import { AMPLITUDE_VENUE_PROFILE_MATCH_FILTER_EVENT } from '../../Matches.constants'

interface Props {
  selectedDate: Date | null
  dispatch: React.Dispatch<Action>
  isMobile?: boolean
}

const DateFilter = ({ selectedDate, dispatch, isMobile }: Props) => {
  const { amplitude } = useAmplitude()

  const handleDateChange = (date: Date | null) => {
    if (!date) return
    dispatch({ type: 'UPDATE_MATCHES_DATE_FILTER', payload: date })
    if (amplitude) {
      amplitude.logEvent(AMPLITUDE_VENUE_PROFILE_MATCH_FILTER_EVENT, { type: DiscoverFilterTypes.date })
    }
  }

  return (
    <DatePicker
      value={selectedDate}
      onChange={handleDateChange}
      isMobile={isMobile}
      variant="simple"
      minWidth="162px"
    />
  )
}

export default DateFilter
